var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 71,
    viewBox: "0 0 218 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_2810)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6824,
    transform: "translate(-611 -3235)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 630,
    transform: "translate(-611 70)",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.672 41.7378C132.161 52.9499 120.044 63.8087 108.353 70.4999C120.044 77.1911 132.161 88.0498 144.672 99.262C167.312 119.552 191.244 141 216.283 141C217.068 141 217.849 140.987 218.628 140.961C219.407 140.987 220.19 141 220.975 141L833.611 141C872.486 141 904 109.436 904 70.5C904 31.564 872.486 0.000115916 833.611 0.000109108L220.975 4.66534e-05C220.19 4.65159e-05 219.408 0.0129155 218.63 0.0384544C217.85 0.0128847 217.068 6.87734e-08 216.283 0C191.244 -2.1924e-06 167.312 21.4475 144.672 41.7378Z",
    fill: "#F2F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3284 41.7378C84.8392 52.95 96.9557 63.8087 108.647 70.4999C96.9557 77.1911 84.8392 88.0498 72.3284 99.262C49.6879 119.552 25.7561 141 0.717529 141C-0.0667725 141 -0.848083 140.987 -1.62622 140.961C-2.40607 140.987 -3.18915 141 -3.97522 141L-672.611 141C-711.486 141 -743 109.436 -743 70.5001C-743 31.5641 -711.486 0.000215237 -672.611 0.000211833L-3.97522 0.000180606C-3.19092 0.000180537 -2.40961 0.0130284 -1.63147 0.0385255C-0.851624 0.0129137 -0.0685425 7.81595e-06 0.717529 7.81595e-06C25.7561 7.81595e-06 49.6879 21.4475 72.3284 41.7378Z",
    fill: "#F2F5F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_2810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 6824,
    fill: "white",
    transform: "translate(-611 -3235)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlice);
export default __webpack_public_path__ + "static/media/Slice.e3d50430e8aabfdf11800bcde015465b.svg";
export { ForwardRef as ReactComponent };